import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IState } from '../../../store';
import { returnBackToForm } from '../../../actions/requestDemand';
import {
  verifyPhoneErrorMessage,
  verifyPhoneSecondsToRetrySms,
  verifyPhoneSecondsToRetrySmsChangedAction,
  verifyPhoneShow,
} from '@cian/sms-validation-widget';
import { selectDemandRequestPhone, selectIsSmsVerificationModalOpen } from '../../../selectors/requestDemand';
import { verifyPhoneRetry } from '../../../store/verifyPhone/verifyPhoneRetryThunk';
import { verifyPhoneRequest } from '../../../store/verifyPhone/verifyPhoneThunk';
import { RequestDemandVerifySms } from './RequestDemandVerifySms';
import { selectSelectedUserType } from '../../../selectors/requestDemand/selectSelectedUserType';

export const mapStateToProps = (state: IState) => {
  return {
    selectedUserType: selectSelectedUserType(state),
    isSmsVerificationModalOpen: selectIsSmsVerificationModalOpen(state),
    demandRequestPhone: selectDemandRequestPhone(state),
    showVerifyPhone: verifyPhoneShow(state),
    verificationError: verifyPhoneErrorMessage(state),
    secondsToRetrySms: verifyPhoneSecondsToRetrySms(state),
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<IState>) => ({
  retrySendingSms() {
    dispatch(verifyPhoneRetry(true));
  },
  retrySecondsChange(seconds: number) {
    dispatch(verifyPhoneSecondsToRetrySmsChangedAction(seconds));
  },
  onApprove(smsCode: string) {
    dispatch(verifyPhoneRequest(smsCode, true));
  },
  onReturnBack() {
    dispatch(returnBackToForm());
  },
});

export const RequestDemandVerifySmsContainer = connect(mapStateToProps, mapDispatchToProps)(RequestDemandVerifySms);
